<template>
  <div class="vuestic-pre-loader-stsc">
    <fingerprint-spinner
      :animation-duration="1500"
      :size="104"
      color="#F9B542"
    />
  </div>
</template>

<script>
  import { FingerprintSpinner } from 'epic-spinners'

  export default {
    name: 'vuestic-pre-loader-stsc',

    components: {
      'fingerprint-spinner': FingerprintSpinner
    },
  }
</script>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-preloader-stsc/VuesticPreLoaderSTSC.vue